/**
 * Analytics Hook
 *
 * Provides a React hook interface to the analytics service.
 * Wraps the Firebase analytics utility.
 */

import { useCallback } from 'react';
import analytics from '../utils/analytics';

/**
 * Hook to access analytics tracking
 * @returns {Object} Analytics methods
 */
export const useAnalytics = () => {
  const track = useCallback((eventName, eventData) => {
    analytics.sendEvent(eventName, eventData);
  }, []);

  return {
    track,
    sendEvent: track, // Alias for compatibility
    setUser: analytics.setUser
  };
};
